var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('component-form-button-icon',{class:( _obj = {}, _obj[_vm.$style.button] = true, _obj[_vm.$style.buttonActive] = _vm.inCompare, _obj ),attrs:{"title":_vm.inCompare ? 'Удалить из сравнения' : 'Добавить в сравнение',"loading":_vm.isLoading,"icon":_vm.mdiPoll,"size":22},on:{"click":_vm.addToCompare}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }